var map = {
	"./de-DE.json": "XV8n",
	"./en-US.json": "gusi",
	"./es-ES.json": "1C3J",
	"./fr-FR.json": "M8le",
	"./it-IT.json": "GZ7E",
	"./nl-NL.json": "V2zN",
	"./pt-PT.json": "k2Mt",
	"./ru-RU.json": "+fsQ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3erO";